import tooltip from './tooltip.vue';

const $tooltip = function(msg, options = {}) {
    let r;
    let anchor;
    if (msg != null && typeof msg === 'object') {
        // Legacy API
        anchor = msg.anchor ? (msg.anchor.$el || msg.anchor) : this.$el;
        r = this.$overlay(tooltip, {
            msg: msg.msg,
            anchor,
            tone: ((msg.cls || '').match(/bg-(.*)/) || [])[1],
            align: msg.halign == 'right' ? 'end' : 'start'
        });
    } else {
        anchor = options.anchor;
        r = this.$overlay(tooltip, { ...options, msg, anchor });
    }

    r.open();

    // Return a close method
    return {
        close() {
            if (r.anchor === anchor) {
                r.close();
            }
        }
    }
}


$tooltip.close = function(anchor, tone) {
    if (anchor._tt && (tone == null || tone == anchor._tt.tone)) {
        anchor._tt.close();
    }
}


export default $tooltip;
